$(function () {

  // IR判定
  var userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.indexOf("msie") > -1 || userAgent.indexOf("trident/7.0") > -1) {
    $("body").addClass("ie");
  }
  
  mobileFooterMenu();
});

/*
    フッターメニュー
====================================*/
function mobileFooterMenu() {
  $('#footer-main dt').off();
  $('#footer-main dt').on('click', function() {
    bp = getBreakpoint();
    if (bp < 992) {
      var menuH = $(this).next().find('ul').innerHeight();
      $(this).parents('dl').toggleClass('is-open');
      var opnFlag = $(this).parents('dl').hasClass('is-open');
      if (opnFlag) {
        $(this).nextAll('dd').css('height', menuH);
      } else {
        $(this).nextAll('dd').removeAttr('style');
      }
      return false;
    }
  });
}

/*
    ブレークポイント取得
====================================*/
function getBreakpoint() {
  if (window.matchMedia('(min-width: 1200px)').matches) {
    return '1200';
  } else if (window.matchMedia('(min-width: 992px)').matches) {
    return '992';
  } else if (window.matchMedia('(min-width: 768px)').matches) {
    return '768';
  } else if (window.matchMedia('(min-width: 576px)').matches) {
    return '576';
  } else {
    return '575';
  }
}
